import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface SignetActivePictoProps extends pictoProps {
}

export interface SignetActivePictoState extends pictoState {
}

export class SignetActivePicto extends Picto<SignetActivePictoProps,SignetActivePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.signetActivePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(SignetActivePicto);
